import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from "react-router-dom";

import { appActions } from '@/store/actions/app.actions';

import styles from '@/views/components/Cookies/Cookies.module.scss';

const Cookies = () => {
	const dict = useSelector((state) => state.app.dict);

	const dispatch = useDispatch();

	const setCookiePermission = () => {
		dispatch(appActions.setCookiePermission());
	};
    
	return (
		<div className={ styles['cookies'] }>
			<div className={ styles['cookies__wrapper'] }>
				<span className={ styles['cookies__title'] }>
					<i className='icon-cookies' />
					{dict.cookies.title}
				</span>
				<span className={ styles['cookies__text'] }>
					{dict.cookies.text1}
					<Link
						className={ styles['cookies__left-link'] }
						to={ '/cookies' }
					>
						{dict.cookies.link}
					</Link>
					{dict.cookies.text2}
				</span>
				
				<button 
					className={ styles['cookies__btn'] }
					onClick={ () => setCookiePermission() }
				>
					{dict.cookies.agree}
				</button>
			</div>
		</div>
	);
};

export default Cookies;